import {createApp} from "vue";

import './styles';
import './icons';
import 'bootstrap/dist/js/bootstrap.js';
import App from "./App.vue";
import { SwiperSlide } from "swiper/vue";
import { library } from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon, FontAwesomeLayers} from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'


const app = createApp(App);
library.add(fas,fab)
app.component('font-awesome-layers', FontAwesomeLayers)
app.component('font-awesome-icon', FontAwesomeIcon)
app.component('swiper-slide', SwiperSlide);
app
    .mount("#website")
;
